<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <fa-icon class="prompt-icon text-primary" [icon]="faCircleQuestion"></fa-icon>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-sm-12 col-12">
            <p [innerHtml]="message"></p>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-12">
            <div class="form-group">
                <input id="prompt1" type="checkbox" [(ngModel)]="boolVal1" name="boolVal1" />
                <label for="prompt1">&nbsp; {{ input1Label }}</label>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="input2Label">
        <div class="col-sm-12 col-12">
            <div class="form-group">
                <input id="prompt2" type="checkbox" [(ngModel)]="boolVal2" name="boolVal2" />
                <label for="prompt2">&nbsp; {{ input2Label }}</label>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button id="btnConfirmYes" type="button" class="btn btn-primary" (click)="yes()">Yes</button>
    <button id="btnConfirmNo" type="button" class="btn btn-secondary" (click)="no()">No</button>
</div>
